import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'fill',
    standalone: false
})
export class FillPipe implements PipeTransform {
  transform(value) {
    if (value > 0) {
      return Array(value);
    } else {
      return [];
    }
  }
}
